export default "__VITE_ASSET__6c876892__"